<template>
  <span
    :class="{ disabled: canNotModified }"
    class="modify"
    @click.prevent.stop="modifyOrder"
  >
    <icon name="modify" />
    <span>{{ $t('trade.orders.modification') }}</span>
  </span>
</template>
<script>
import Icon from 'com/Icon'
import { ORDER_STATUS, OMNIBUS_ORDER_STATUS, ORDER_TYPE } from 'const/trade'
import { mapGetters } from 'vuex'
import { getQuoteDetail } from 'apis/quote'

export default {
  components: {
    Icon
  },
  props: {
    order: {
      required: true
    }
  },
  computed: {
    ...mapGetters(['isIb']),
    canNotModified() {
      if (this.isIb) {
        return (
          this.order.orderType === ORDER_TYPE.MKT ||
          this.order.status === ORDER_STATUS.NO_RESULT
        )
      } else {
        return this.order.status !== OMNIBUS_ORDER_STATUS.NEW
      }
    }
  },
  methods: {
    modifyOrder() {
      if (this.canNotModified) return
      getQuoteDetail(this.order).then(detail => {
        this.$store.dispatch('newTradeRequest', {
          stock: detail,
          isModify: true,
          order: this.order
        })
      })
    }
  }
}
</script>
